import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';

import { useDeferUpdate } from '../../context/DeferUpdateContext';

import updateRequired from '../../assets/images/update-cog.svg';

function Module6() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

    const handleSuccess = () => {
    setCanContinue(true);
  };
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  const showAfterSeconds = 1; // Seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);

  // Show/hide popup div content
  const [activeDiv, setactiveDiv] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0); // Used to force re-render

  const handleOpen = (divId) => {
    setactiveDiv(divId);
    if (divId =='4' ){ // auto start the countdown on Popup div 4
      startCountdown();
    }
  };

  const handleClose = () => {
    setactiveDiv(null);
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Dynamically add CSS style classes to elements
  const [styledId, setStyledId] = useState(null);

  const handleStyleChange = (targetId) => {
    setStyledId(targetId);
  };


  // Defer update button
  const { setDeferUpdate } = useDeferUpdate();

  const handleDefer1 = () => {
    setDeferUpdate(true);
    console.log('Defer update true');
  };

   const handleDefer2 = () => {
    setDeferUpdate(false);
    console.log('Defer update false');
  };

  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


    // Go to next page
    const { goNext } = usePageControl();


  return (
    <div id="module-6" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">

      <Popup
        className="popup-box-no-footer"
        title="Update Required"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
      >
      <div className="alert-image text-center"><img src={updateRequired} className="update-required spin" alt="Update Required"/></div>
      <h1>Update Your System</h1>
      {activeDiv === null && (
        <div>
          <p>You've managed to get back in to the restored system, but it's now asking you to update your system to remove vulnerabilities.</p>
          <p>Will you:</p>
          <button id="button1" onClick={() => { handleOpen(1); handleDefer1(); }} className="btn popup-option">Defer</button>
          <button id="button2" onClick={() => { handleOpen(2); handleDefer2(); }} className="btn popup-option">Install updates (approximately 45 seconds)</button>
        </div>
      )}

      {activeDiv === 1 && (
        <div key={`1-${refreshKey}`} id="alert-message-1">
          <h2>Updates deferred</h2>
          <p>You've saved time!</p>
          <p>You can now continue.</p>
          {/* <button className="btn" onClick={() => { handleClose(); handleSuccess(); setShowPopup(false) }}>Close</button> */}
          {/* Client request: Go to the next page immediately if answer is correct (3 of 3) */}
          <button className="btn" onClick={() => { goNext(); }}>Close</button>
        </div>
      )}

      {activeDiv === 2 && (
        <div key={`2-${refreshKey}`} id="alert-message-2">
          <h2>Installing updates</h2>
          <div id="loader"><div id="loader-bar" className="loader-bar-duration-10"></div></div>
          <div className="opacity-show delay-11">
            <p>You've successfully installed the latest updates!</p>
            <p>You can now continue.</p>
            {/* <button className="btn" onClick={() => { handleClose(); handleSuccess(); setShowPopup(false) }}>Close</button> */}
            <button className="btn" onClick={() => { goNext(); }}>Close</button>
          </div>
        </div>
      )}  

      </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module6;
